import { vuex as app } from '../modules'

export default { ...app.modules }
